import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import DetailTemplate from '../../common/template/DetailTemplate';
import CostCalcLockContainer from '../../../containers/projectmng/costcalc/CostCalcLockContainer';
import PurchaseBillHistoryContainer from '../../../containers/projectmng/bill_mng/PurchaseBillHistoryContainer';
import PurchaseBillFormContainer from '../../../containers/projectmng/bill_mng/PurchaseBillFormContainer';

const PurchaseBillRegisterTemplate = () => {
  const { project } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
  }));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <Box
        sx={{
          py: 2,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle2" color={'error.main'} component="div">
          받은 발주서 / 보낸 발주서를 업로드 해야 세금계산서 발행이 가능합니다.
          <br />
          작성 여부를 확인하십시오.
        </Typography>
      </Box>
      <DetailTemplate title="원가 산출 내역">
        <CostCalcLockContainer project={project} />
      </DetailTemplate>
      <DetailTemplate title="매입 계산서 등록 사항">
        <PurchaseBillHistoryContainer project={project} isEdit />
      </DetailTemplate>
      <DetailTemplate title="매입 계산서 신규 등록">
        <PurchaseBillFormContainer project={project} />
      </DetailTemplate>
    </Box>
  );
};

export default PurchaseBillRegisterTemplate;
